import(/* webpackMode: "eager", webpackExports: ["Courses"] */ "/vercel/path0/apps/web/src/components/home-page/courses.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/vercel/path0/apps/web/src/components/home-page/title.tsx");
